import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ChevronRight = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.739863 0.18925C0.960218 -0.0494681 1.33237 -0.0643542 1.57109 0.156001L4.51226 2.87093C4.75098 3.09129 4.76587 3.46344 4.54551 3.70216C4.32516 3.94088 3.95301 3.95576 3.71429 3.73541L0.773112 1.02048C0.534394 0.80012 0.519508 0.427968 0.739863 0.18925ZM4.95584 4.08092C5.17619 3.8422 5.54834 3.82731 5.78706 4.04767L11.4164 9.24395L1.60316 19.812C1.38209 20.0501 1.0099 20.0639 0.771835 19.8428C0.53377 19.6218 0.519985 19.2496 0.741046 19.0115L9.75136 9.30808L4.98908 4.91214C4.75037 4.69179 4.73548 4.31963 4.95584 4.08092Z"
            fill="currentcolor"
          />
        </svg>
      </Icon>
    );
  },
);

ChevronRight.displayName = "ChevronRight";
